import { Flex, Text } from 'src/components';
import styled from "@emotion/styled";

const StatusMessageStyle = styled.div({
  width: '100%',
  backgroundColor: 'transparent',
})

const FlexContainerStyle = styled(Flex)({
  marginBottom: 16,
})

const FlexMessageIconStyle = styled(Flex)({
  width: 48,
  height: 48,
  marginBottom: 16,
})

const StatusMessageTitleContainerStyle = styled.div({
  textAlign: 'center',
})

const StatusMessageTitleStyle = styled.div({
  marginBottom: 8,
})

export interface StatusMessageProps {
  icon?: React.ReactNode;
  title?: string;
  subtitle?: string;
  barcode?: React.ReactNode;
  buttons?: React.ReactNode;
}

export const StatusMessage: React.FC<StatusMessageProps> = ({
  icon,
  title,
  subtitle,
  barcode,
  buttons,
}) => (
  <StatusMessageStyle>
    <FlexContainerStyle vertical align='center'>
      {icon && <FlexMessageIconStyle>{icon}</FlexMessageIconStyle>}
      <StatusMessageTitleContainerStyle>
        <StatusMessageTitleStyle><Text type="large" bold>{title}</Text></StatusMessageTitleStyle>
        <StatusMessageTitleStyle><Text type="base" dangerouslySetInnerHTML={{ __html: subtitle || '' }}></Text></StatusMessageTitleStyle>
      </StatusMessageTitleContainerStyle>
    </FlexContainerStyle>
    {barcode}
    {buttons}
  </StatusMessageStyle>
);
